import React from 'react';
import { Wand2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white py-20 px-6 mt-auto">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <span className="text-2xl font-black">Fluxara</span>
            </div>
            <p className="text-gray-400 mb-6">
              Create stunning AI-powered designs in seconds. No design skills required.
            </p>
            <div className="flex gap-4">
              {['Twitter', 'Instagram', 'LinkedIn'].map((social, index) => (
                <div key={index} className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer">
                  <span className="text-xs">📱</span>
                </div>
              ))}
            </div>
          </div>

          {/* Product */}
          <div>
            <h3 className="font-bold text-lg mb-4">Product</h3>
            <ul className="space-y-3 text-gray-400">
              <li className="hover:text-cyan-400 cursor-pointer transition-colors" onClick={() => navigate('/features')}>Features</li>
              <li className="hover:text-cyan-400 cursor-pointer transition-colors" onClick={() => navigate('/pricing')}>Pricing</li>
              <li className="hover:text-cyan-400 cursor-pointer transition-colors" onClick={() => navigate('/use-cases')}>Use Cases</li>
              <li className="hover:text-cyan-400 cursor-pointer transition-colors" onClick={() => navigate('/generate')}>Design Gallery</li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-bold text-lg mb-4">Resources</h3>
            <ul className="space-y-3 text-gray-400">
              <li className="hover:text-cyan-400 cursor-pointer transition-colors" onClick={() => navigate('/guides')}>Guides</li>
              <li className="hover:text-cyan-400 cursor-pointer transition-colors" onClick={() => navigate('/blog')}>Blog</li>
              <li className="hover:text-cyan-400 cursor-pointer transition-colors" onClick={() => navigate('/api-docs')}>API Docs</li>
              <li className="hover:text-cyan-400 cursor-pointer transition-colors" onClick={() => navigate('/support')}>Support</li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-bold text-lg mb-4">Legal</h3>
            <ul className="space-y-3 text-gray-400">
              <li className="hover:text-cyan-400 cursor-pointer transition-colors" onClick={() => navigate('/privacy')}>Privacy Policy</li>
              <li className="hover:text-cyan-400 cursor-pointer transition-colors" onClick={() => navigate('/terms')}>Terms of Use</li>
              <li className="hover:text-cyan-400 cursor-pointer transition-colors" onClick={() => navigate('/license')}>License</li>
              <li className="hover:text-cyan-400 cursor-pointer transition-colors" onClick={() => navigate('/cookie-policy')}>Cookie Policy</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8 mt-12">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © 2025 Fluxara. All rights reserved. Made with ❤️ for creators.
            </p>
            <div className="flex gap-6 text-sm text-gray-400">
              <span className="hover:text-cyan-400 cursor-pointer transition-colors">Status</span>
              <span className="hover:text-cyan-400 cursor-pointer transition-colors">Changelog</span>
              <span className="hover:text-cyan-400 cursor-pointer transition-colors" onClick={() => navigate('/support')}>Contact</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
